module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isIncVat),
      expression: "isIncVat"
    }],
    attrs: {
      "type": "checkbox",
      "id": "isIncVat"
    },
    domProps: {
      "checked": Array.isArray(_vm.isIncVat) ? _vm._i(_vm.isIncVat, null) > -1 : (_vm.isIncVat)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.isIncVat,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isIncVat = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isIncVat = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isIncVat = $$c
        }
      }, function($event) {
        _vm.setVat(), _vm.refresh()
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "isIncVat"
    }
  }, [_vm._v("inclusief b.t.w.")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.period),
      expression: "period"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.period = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.refresh()
      }]
    }
  }, _vm._l((_vm.periodArray), function(months, period) {
    return _c('option', {
      key: period
    }, [_vm._v(_vm._s(period))])
  }), 0), _vm._v(" "), (!_vm.period.includes('Vorig')) ? _c('div', {
    staticStyle: {
      "display": "inline"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isUpToToday),
      expression: "isUpToToday"
    }],
    attrs: {
      "type": "checkbox",
      "id": "isUpToToday"
    },
    domProps: {
      "checked": Array.isArray(_vm.isUpToToday) ? _vm._i(_vm.isUpToToday, null) > -1 : (_vm.isUpToToday)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.isUpToToday,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isUpToToday = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isUpToToday = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isUpToToday = $$c
        }
      }, function($event) {
        _vm.refresh()
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "isUpToToday"
    }
  }, [_vm._v("tot vandaag")])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "content-heading"
  }, [_c('i', {
    staticClass: "si si-tag mr-5"
  }), _vm._v(" Producten " + _vm._s((_vm.period === "Dit jaar" ? "in dit jaar t.o.v. vorig jaar" : "in " + _vm.period.toLowerCase() + " van dit jaar t.o.v. van vorig jaar")) + "\n  ")]), _vm._v(" "), _c('api-table-block', {
    ref: "productsTable",
    attrs: {
      "fields": _vm.fields,
      "items": _vm.findAllProducts,
      "default-sort-by": "total_revenue",
      "item-label-singular": "product",
      "item-label-plural": "producten"
    },
    scopedSlots: _vm._u([{
      key: "name",
      fn: function(data) {
        return [_vm._v("\n      " + _vm._s(data.value) + "\n    ")]
      }
    }, {
      key: "total_revenue",
      fn: function(data) {
        return [_vm._v("\n      " + _vm._s(_vm._f("money")(_vm.correction * Number(data.value))) + "\n      "), _c('b', [_c('small', {
          class: data.item.improvement_revenue >= 0 ? 'text-success' : 'text-danger'
        }, [_vm._v(_vm._s(data.item.improvement_revenue) + _vm._s(data.item.improvement_revenue ? '%' : ''))])])]
      }
    }, {
      key: "total_revenue_last_year",
      fn: function(data) {
        return [_vm._v("\n      " + _vm._s(_vm._f("money")((data.value ? _vm.correction * Number(data.value) : ''))) + "\n    ")]
      }
    }, {
      key: "total_sold",
      fn: function(data) {
        return [_vm._v("\n      " + _vm._s(Number(data.value)) + "\n      "), _c('b', [_c('small', {
          class: data.item.improvement_sold >= 0 ? 'text-success' : 'text-danger'
        }, [_vm._v(_vm._s(data.item.improvement_sold) + _vm._s(data.item.improvement_sold ? '%' : ''))])])]
      }
    }, {
      key: "total_sold_last_year",
      fn: function(data) {
        return [_vm._v("\n      " + _vm._s(data.value ? Number(data.value) : '') + "\n    ")]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15215781","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/reports/ReportProductsPage.vue
// module id = 695
// module chunks = 1